import { DfeInventoryEntry } from '@/lib/api';
import { InventoryItemCard } from './InventoryItemCard';
import { Skeleton } from '@/components/ui/skeleton';

interface InventoryGridProps {
  items: DfeInventoryEntry[];
  loading: boolean;
  conflictItemDefIds?: Set<string>;
  onTransfer?: (item: DfeInventoryEntry) => void;
  onDelete?: (item: DfeInventoryEntry) => void;
  onClick?: (item: DfeInventoryEntry) => void;
}

export function InventoryGrid({
  items,
  loading,
  conflictItemDefIds,
  onTransfer,
  onDelete,
  onClick,
}: InventoryGridProps) {
  if (loading && items.length === 0) {
    return (
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="space-y-2">
            <Skeleton className="aspect-square w-full rounded-lg" />
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-3 w-1/2" />
          </div>
        ))}
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <div className="text-center py-12 text-muted-foreground">
        <p>No items found in your inventory.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
      {items.map((item) => (
        <InventoryItemCard
          key={item.itemId || item.balanceId || `${item.itemDefId}-balance`}
          item={item}
          hasConflict={conflictItemDefIds?.has(item.itemDefId)}
          onTransfer={onTransfer}
          onDelete={onDelete}
          onClick={onClick}
        />
      ))}
    </div>
  );
}
